// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"ae32d14c","513":"456b663f","703":"642f5b96","787":"077dbc09"}[chunkId] + ".chunk.js";
};